import { IAjaxConfig } from '../helpers';

export class EnumApiPolymerization {
  /**
   * @dec 验证用户身份是否为增值经销商/已签约D店面
   */
  readonly reporting_business_identity: IAjaxConfig = {
    url: '/api/gateway/bp-polymerization/portal/v1/reporting/business/identity',
    method: 'get',
  };
  /**
   * @dec sn码批量上报（PC端用）
   */
  readonly reporting_business_submit: IAjaxConfig = {
    url: '/api/gateway/bp-polymerization/portal/v1/reporting/business/submit',
    method: 'post',
  };
  /**
   * @dec sn码导入上报
   */
  readonly reporting_business_upload: IAjaxConfig = {
    url: '/api/gateway/bp-polymerization/portal/v1/reporting/business/upload',
    method: 'post',
  };
  /**
   * @dec sn码导入模板下载
   */
  readonly reporting_business_template: IAjaxConfig = {
    url: '/api/gateway/bp-polymerization/portal/v1/reporting/business/template',
    method: 'post',
  };
  /**
   * @dec sn码信息页面查询
   */
  readonly reporting_business_list: IAjaxConfig = {
    url: '/api/gateway/bp-polymerization/portal/v1/reporting/business/list',
    method: 'post',
  };
  /**
   * @dec sn码信息详情查询
   */
  readonly reporting_business_detail: IAjaxConfig = {
    url: '/api/gateway/bp-polymerization/portal/v1/reporting/business/detail',
    method: 'get',
  };
  /**
   * @dec sn码信息导出
   */
  readonly reporting_business_download: IAjaxConfig = {
    url: '/api/gateway/bp-polymerization/portal/v1/reporting/business/download',
    method: 'post',
  };
  /**
   * @dec sn码上传错误信息导出
   */
  readonly reporting_business_fail: IAjaxConfig = {
    url: '/api/gateway/bp-polymerization/portal/v1/reporting/business/fail',
    method: 'get',
  };
  /**
   * @dec sn码单条上报（移动端用）
   */
  readonly reporting_business_submit_single: IAjaxConfig = {
    url: '/api/gateway/bp-polymerization/portal/v1/reporting/business/submit/single',
    method: 'post',
  };
}
